import { ColDef, ICellRendererParams } from "ag-grid-community";
import { ResourceCreationData } from "../../../../../../../services/cloudchipr.api";
import { CreatedByCellRenderer } from "../column-def-cell-renderers/CreatedByCellRenderer";

export const resourceCreatedByColumnDef: ColDef = {
  field: "resource.creation_data",
  headerName: "Created By",
  headerTooltip:
    "The Created By value is only available for resources created within the last 90 days.",
  valueGetter: ({ data }) => data?.resource?.creation_data?.creator,
  cellRenderer: ({ data }: ICellRendererParams) => {
    if (!data) {
      return null;
    }

    const creationData = data?.resource?.creation_data as ResourceCreationData;

    return <CreatedByCellRenderer data={creationData} />;
  },
};
